module.exports = __webpack_public_path__ + "img/block6-card1.8c1c30db.svg";